import { render, staticRenderFns } from "./Interprets.vue?vue&type=template&id=32f69c45&lang=html&"
import script from "./Interprets.vue?vue&type=script&lang=js&"
export * from "./Interprets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports